<template>
    <div class="category-row">
        <button v-if="this.arrow === `down`" @click.stop="toggle(category, `down`)" class="category"><a href="#" @click.stop="toggle(category, `down`)">{{this.category.category}}</a></button>
        <van-icon v-if="this.arrow === `down`" @click.stop="toggle(category, `down`)" name="arrow" class="arrow"/>

        <button v-if="this.arrow === `up`" @click.stop="toggle(category, `up`)" class="category"><a class="link" @click.stop="select(category)">{{this.category.category}}</a></button>
        <van-icon v-if="this.arrow === `up`" @click.stop="toggle(category, `up`)" name="arrow" class="arrow"/>
    </div>
</template>

<script>
export default {
    name: "CategoryRow",

    props: {
        onToggle: Function,
        onSelect: Function,
        arrow: String,
        category: Object,
    },

    methods: {
        select(c) {
            if (this.onSelect) {
                this.onSelect(c);
            }
        },

        toggle(c, d) {
            if (this.onToggle) {
                this.onToggle(c, d);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.category-row {
    width: 100%;
    height: 88px;
    background: $fc02;
    border-radius: $br20;
    box-shadow: $box-shadow1;
    padding: 0 20px 0 30px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .arrow {
        width: 88px;
        text-align: center;
        border-left: solid 2px #f1f2f6;
        height: 88px;
        line-height: 88px;
        font-size: 24px;
    }

    .category {
        width: 100%;
        height: 100%;
        text-align: left;
        border: none;
        outline: none;
        font-size: 24px;
        background-color: #fff;

        a {
            text-decoration: blue;
            cursor: pointer;
            color: #409eff;

            &:hover {
                color: #1462af;
                text-decoration: underline;
            }
        }
    }
}
</style>
